import Meta from '@/components/common/Meta'

import LuggageStorageForBusinessTravelersPage from '@/v2/components/pages/landing-pages/luggage-storage-for-business-travelers-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/luggage-storage-for-business-travelers-page'

interface LuggageStorageForBusinessTravelersPageProps {}

const Page: React.FC<LuggageStorageForBusinessTravelersPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.luggage_storage_for_business_travelers.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.luggage_storage_for_business_travelers?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.luggage_storage_for_business_travelers?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <LuggageStorageForBusinessTravelersPage />
    </>
  )
}

export default Page
